import React from "react";

type SaveProps = {
  color?: string;
};

const Save: React.FC<SaveProps> = ({ color = "#000000" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.25 8.5V9.25H7H14H14.75V8.5V7V6.25H14H7H6.25V7V8.5ZM16.6893 3.75L20.25 7.31066V19C20.25 19.3495 20.1344 19.6303 19.8827 19.8827C19.6303 20.1344 19.3495 20.25 19 20.25H5C4.65058 20.25 4.36988 20.1345 4.11755 19.8829C3.86563 19.6304 3.75 19.3496 3.75 19V5C3.75 4.65048 3.86557 4.36972 4.11733 4.11733C4.36972 3.86557 4.65048 3.75 5 3.75H16.6893Z"
        stroke="black"
        strokeWidth="1.5"
      />
      <circle
        cx="12"
        cy="15"
        r="2"
        fill={color}
        stroke={color}
        strokeWidth="3"
      />
    </svg>
  );
};

export default Save;
